import { render, staticRenderFns } from "./MainSidebarToggle.vue?vue&type=template&id=5599b58e&scoped=true"
import script from "./MainSidebarToggle.vue?vue&type=script&lang=js"
export * from "./MainSidebarToggle.vue?vue&type=script&lang=js"
import style0 from "./MainSidebarToggle.vue?vue&type=style&index=0&id=5599b58e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5599b58e",
  null
  
)

export default component.exports